import React from 'react';
import { Box, Link, Typography } from '@mui/material';

const SIZES = { md: { w: 48, h: 64 }, lg: { w: 90, h: 120 } };

// Moved from PartnerMatchesPage.js (2026-10-01) so the Buyer Insights tabs reuse it.
export const ImagePlaceholder = ({ width = 48, height = 64 }) => (
  <Box
    sx={{
      width,
      height,
      borderRadius: 1,
      flexShrink: 0,
      bgcolor: 'grey.200',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography variant="caption" color="text.secondary">N/A</Typography>
  </Box>
);

// `children` (optional) renders under the subtitle, to the right of the image — the Buyer
// Insights tab puts its status pill, size chips and status line there. `url` turns the name into a link to the product page;
// `size` 'md' (48×64, default) or 'lg' (90×120); `extra` is a third subtitle part (category).
const ProductCell = ({ name, brand, color, extra, image, url, size = 'md', children }) => {
  const [imgError, setImgError] = React.useState(false);
  const dims = SIZES[size] || SIZES.md;
  const subtitle = [brand, color].filter(Boolean).join(' • ');

  return (
    <Box sx={{ display: 'flex', alignItems: children ? 'flex-start' : 'center', gap: 1.5, py: 0.5, minWidth: 0 }}>
      {image && !imgError ? (
        <Box
          component="img"
          src={image}
          alt={name}
          referrerPolicy="no-referrer"
          onError={() => setImgError(true)}
          sx={{
            width: dims.w,
            height: dims.h,
            objectFit: 'cover',
            borderRadius: 1,
            flexShrink: 0,
            bgcolor: 'grey.100',
          }}
        />
      ) : (
        <ImagePlaceholder width={dims.w} height={dims.h} />
      )}
      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }} noWrap>
          {url ? (
            <Link href={url} target="_blank" rel="noopener noreferrer" underline="hover" color="inherit">
              {name || 'Unknown product'}
            </Link>
          ) : (
            name || 'Unknown product'
          )}
        </Typography>
        {(subtitle || extra) && (
          <Typography variant="caption" color="text.secondary" noWrap component="div">
            {subtitle}
            {extra ? `${subtitle ? ' · ' : ''}${extra}` : ''}
          </Typography>
        )}
        {children}
      </Box>
    </Box>
  );
};

export default ProductCell;
